@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">{{"allinvoice.loadinglabel" | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
@if (this.firstvalue != 'N/A') {
  <section class="col-xs-12 col-md-12 invoices_midsection">
    <div class="col-xs-12 col-md-5 tablecontainer">
      <div class="form-group invoice_datasearch">
        <div class="col-xs-10 col-md-10 searchbox">
          <div class="input-group invoice_order">
            <div class="input-group-addon"><i class="fa fa-search"></i></div>
            <input class="form-control" id="invoice_search" name="lookup"  type="text" (keyup)="inputSearch($event)">
          </div>
        </div>
        <div class="col-xs-1 col-md-1 filterbox" (click)="filteropen()">
          <img alt="Filter" src="assets/images/filter.png" width="25" alt="filter">
          @if (count>0) {
            <span class="select_counter">{{count}}</span>
          }
          <div class="filterText">{{"allinvoice.filterlabel" | cxTranslate}}</div>
        </div>
        <div class="col-xs-1 col-md-1 sortbox" (click)="sortopen()">
          <img src="assets/images/sort.png" width="25" alt="sort">
          <div class="filterText">{{"allinvoice.sortlabel" | cxTranslate}}</div>
        </div>
      </div>
      <div class="invoice_filtersection">
        <div class="filteropen" (click)="onFilterClick($event)" [ngClass]="togglefilterView?'open':''">
          <div class="statussection">
            <div class="filterheader">{{"allinvoice.bystatus" | cxTranslate}}</div>
            @for (list of getstatus; track list; let i = $index) {
              <div class="invoice_checkboxparent">
                <label class="checkbox-button"> <input type="checkbox" class="invoice_checkbox" name="status" value={{list}} (click)="incrementcountstatus($event,i);applyFilter()" > <span class="checkbox-button__control" ></span></label>
                <label>{{list}}</label>
              </div>
            }
          </div>
          <div class="invoice_reset" id="invoice_resetfilter" (click)="resetFilter()">{{"allinvoice.resettxt" | cxTranslate}}</div>
          <div class="clearfix"></div>
        </div>
        <div class="sortopen" (click)="onFilterClick($event)"[ngClass]="togglesortView?'open':''">
          <div class="invoicesection">
            <div class="filterheader">{{"allinvoice.invnumbertxt" | cxTranslate}}</div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio" class="invoice_radio" name="radiobtn"  value="1to9"(click)="sortTest('1to9')"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.1to9label" | cxTranslate}}</label>
            </div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio" class="invoice_radio" name="radiobtn"  value="9to1" (click)="sortTest('9to1')"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.9to1label" | cxTranslate}}</label>
            </div>
          </div>
          <div class="locationsection">
            <div class="filterheader">{{"allinvoice.loctxt" | cxTranslate}}</div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio" class="invoice_radio" name="radiobtn" (click)="sortTest('AtoZ')" value="AtoZ"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.atozlabel" | cxTranslate}}</label>
            </div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio" class="invoice_radio" name="radiobtn" (click)="sortTest('ZtoA')"  value="ZtoA"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.ztoalabel" | cxTranslate}}</label>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="datesection">
            <div class="filterheader">{{"allinvoice.dateissuedtxt" | cxTranslate}}</div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio" class="invoice_radio" id="invoice_radioIssued" name="radiobtn"  (click)="sortTest('MostRecent')" value="MostRecent"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.mostreclabel" | cxTranslate}}</label>
            </div>
            <div class="invoice_radioparent">
              <label class="radio-button">
                <input type="radio"  class="invoice_radio" name="radiobtn"  (click)="sortTest('LeastRecent')" value="LeastRecent"/>
                <span class="radio-button__control"></span>
              </label>
              <label>{{"allinvoice.leastreclabel" | cxTranslate}}</label>
            </div>
          </div>
          <div class="invoice_reset invoice_resetUK" (click)="resetSort()" id="invoice_resetsortUK">{{"allinvoice.resettxt" | cxTranslate}}</div>
          <div class="clearfix"></div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div id="invoicefilterTable_wrapper" class="dataTables_wrapper no-footer">
        <table id="invoicefilterTable" mat-table [dataSource]="dataSource" matSort class="">
          <ng-container matColumnDef="allinvoices" >
            <th class="odertableheader" mat-header-cell *matHeaderCellDef> order Data </th>
            <td mat-cell *matCellDef="let element" (click)="openrightsection(element.invoiceNumber,element.status)">
              <div class="invoice_firstrow">
                <div class="invoice_no"><div class="invoice_date"><span>{{"allinvoice.invdate" | cxTranslate}}</span>{{element.invoiceDate}}</div><span>Invoice </span><span>#{{element.invoiceNumber}}</span></div>
                <div class="invoice_status" [ngClass]="element.status?element.status:''">{{element.status}}</div>
              </div>
              @if (element.aQIVdoses) {
                <div class="invoice_unit"><span>{{element.aqivProductLabel}} </span><span class="addComma">{{element.aQIVdoses}}</span></div>
              }
              @if (element.qivcdoses) {
                <div class="invoice_unit"><span>{{element.qivcProductLabel}}  </span><span class="addComma">{{element.qivcdoses}}</span></div>
              }
              @if (element.fluaddoses) {
                <div class="invoice_unit"><span>{{element.fluadProductLabel}}  </span><span class="addComma">{{element.fluaddoses}}</span></div>
              }
              @if (element.flucelvaxdoses) {
                <div class="invoice_unit"><span>{{element.flucelvaxProductLabel}}  </span><span class="addComma">{{element.flucelvaxdoses}}</span></div>
              }
              @if (element.aTIVdoses) {
                <div class="invoice_unit"><span>{{element.ativProductLabel}}  </span><span class="addComma">{{element.aTIVdoses}}</span></div>
              }
              <div class="invoice_location"><span>{{"allinvoice.deliveryloc" | cxTranslate}}</span> <span>{{element.location}}</span></div>
              <!-- <input type="hidden" class="searchorder" value="' + full['salesOrderNumber'] + '"><div class = "hidden rbaInvoicePermissions">' + full['rbaPermission'] + '</div> -->
            </td>
          </ng-container>
          <!-- Header and Row Declarations -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row id="{{row.invoiceNumber}}" [class.activeinvoice]="row.invoiceNumber == firstvalue" *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-matching">{{"allinvoice.norecordstxt" | cxTranslate}}</td>
          </tr>
        </table>
        <div class="custom-paginator">
          <button class="pagination-buttonOrg" (click)="goToFirstPage();scrollToTop()" [disabled]="isFirstPage()" id="first-page">
            <img alt="Navigate to previous page" src="assets/images/pagination-double-prev-arrow-icon.svg" class="locations_arrows">
          </button>
          <button class="pagination-buttonOrg" (click)="previousPage();scrollToTop()" [disabled]="isFirstPage()" id="previous-page">
            <img alt="Navigate to previous page" src="assets/images/pagination-prev-btn.svg" class="locations_arrows">
          </button>
          @for (pge of getPages(); track pge) {
            <button [hidden]="!isTableHasData" class="pagination-buttonOrg" [class.active-page]="isCurrentPage(pge)" (click)="goToPage(pge);scrollToTop()">
              {{pge}}
            </button>
          }
          <button class="pagination-buttonOrg" (click)="nextPage();scrollToTop()" [disabled]="isLastPage()" id="next-page">
            <img alt="Navigate to next page" src="assets/images/pagination-next-btn.svg" class="locations_arrows">
          </button>
          <button class="pagination-buttonOrg" (click)="goToLastPage();scrollToTop()" [disabled]="isLastPage()" id="last-page">
            <img alt="Navigate to last page" src="assets/images/pagination-double-next-arrow-icon.svg" class="locations_arrows">
          </button>
        </div>
      </div>
    </div>
    @if (rightsectionresponse) {
      <div class="col-xs-12 col-md-7 invoices_rightsection">
        <div class="col-xs-12 col-md-12 invoice_details" id="invoice_{{rightsectionresponse.invoiceNumber}}">
          <div class="invoice_topHeader">
            <div class="invoice_no">{{"allinvoice.invoicenumlabel" | cxTranslate}}
              <span class="invoice_fetch_id">{{rightsectionresponse.invoiceNumber}}</span>
              <div class="invoice_download">
                <span>{{"allinvoice.downloadpdftxt" | cxTranslate}}</span>
                <span>
                  <img src="assets/images/icon-download.svg" width="15" alt="download" (click)="downloadInvoice(rightsectionresponse.invoiceNumber)">
                </span>
              </div>
            </div>
            <div class="invoice_detailpdf" [innerHTML]="'allinvoice.needhelptxt' | cxTranslate">
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="row invoice_topHeader">
            <div class="col-md-3 invoice_duedate">
              <label>{{"allinvoice.paydueon" | cxTranslate}}</label>
              <div>{{rightsectionresponse.paymentDueDate}}</div>
            </div>
            <div class="col-md-3 invoice_issueddate">
              <label>{{"allinvoice.invoicedate" | cxTranslate}}</label>
              <div>{{rightsectionresponse.invoiceDate}}</div>
            </div>
            <div class="col-md-3 invoice_totalcost">
              <label>{{"allinvoice.amntdue" | cxTranslate}}</label>
              <div>
                <span>
                  @if (rightsectionresponse.status == 'PAID') {
                    &#163;{{0 | number : '1.2-2'}}
                  } @else {
                    &#163;{{rightsectionresponse.total | number : '1.2-2'}}
                  }
                </span>
              </div>
            </div>
            <div class="col-md-3 invoice_detailstatusParent">
              <div class="invoice_detailstatus {{rightsectionresponse.invoiceStatus}}">{{rightsectionresponse.invoiceStatus}}</div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="invoice_topHeader">
            <div class="invoice_detailbox1">
              <div class="invoice_boxdetail invoice_detailPO">
                <div class="invoice_detaillabel invoice_detailPOlabel">{{"allinvoice.custPOnum" | cxTranslate}}</div>
                <div class="invoice_detailno invoice_detailPOno">{{rightsectionresponse.poNumber}}</div>
                <div class="invoice_detailissued invoice_detailPOissued">{{"allinvoice.issuedonlabel" | cxTranslate}}<span>{{rightsectionresponse.poDate}}</span>
              </div>
            </div>
          </div>
          <div class="invoice_detailbox2">
            <div class="invoice_boxdetail invoice_detailorder">
              <div class="invoice_detaillabel invoice_detailorderlabel">{{"allinvoice.salesordernum" | cxTranslate}}</div>
              <div class="invoice_detailno invoice_detailorderno">#{{rightsectionresponse.salesOrderNumber}}</div>
            </div>
            <div class="invoice_boxdetail invoice_detaildelivery">
              <div class="invoice_detaillabel invoice_detaildeliverylabel">{{"allinvoice.deliveryno" | cxTranslate}}
              </div>
              <div class="invoice_detailno invoice_detaildeliveryno">@if (rightsectionresponse.deliveryNumber) {
                {{rightsectionresponse.deliveryNumber}}
              } @else {
                NA
              }</div>
            </div>
          </div>
          <div class="invoice_detailbox3">
            <div class="invoice_boxdetail invoice_detailship">
              <div class="invoice_detaillabel invoice_detailshiplabel">{{"allinvoice.shiptolabel" | cxTranslate}}</div>
              <div class="invoice_detailno invoice_detailshipno">#{{rightsectionresponse.shipTo.shipToId}}</div>
              <div class="invoice_detaillabel invoice_detailshiploc">{{"allinvoice.locname" | cxTranslate}}</div>
              <div class="invoice_detailissued invoice_detailshipaddress">
                {{rightsectionresponse.shipTo.shipToStreet}}<br>{{rightsectionresponse.shipTo.shipToCity}}<br>{{rightsectionresponse.shipTo.zipCode}}
              </div>
            </div>
            <div class="invoice_boxdetail invoice_detailbil">
              <div class="invoice_detaillabel invoice_detailbilllabel">{{"allinvoice.soldtolabel" | cxTranslate}}</div>
              <div class="invoice_detailno invoice_detailbillno">#{{rightsectionresponse.soldTo.soldToId}}</div>
              <div class="invoice_detaillabel invoice_detailbillloc">{{"allinvoice.locname" | cxTranslate}}</div>
              <div class="invoice_detailissued invoice_detailbilladdress">
                {{rightsectionresponse.soldTo.soldToStreet}}<br>{{rightsectionresponse.soldTo.soldToCity}}<br>{{rightsectionresponse.soldTo.zipCode}}
              </div>
            </div>
          </div>
          <div class="invoice_products">
            <div class="invoice_productsHeader">{{"allinvoice.productsinvoiced" | cxTranslate}}</div>
            <table class="invoice_productsTable">
              <thead>
                <tr>
                  <th>{{"allinvoice.prodname" | cxTranslate}}</th>
                  <th>{{"allinvoice.materialno" | cxTranslate}}</th>
                  <th>{{"allinvoice.qty" | cxTranslate}}</th>
                  <th>{{"allinvoice.unitprice" | cxTranslate}}</th>
                  <th>{{"allinvoice.totalamnt" | cxTranslate}}</th>
                </tr>
              </thead>
              <tbody>
                @for (items of rightsectionresponse.lineItems; track items) {
                  <tr>
                    <td>{{items.productName}}</td>
                    <td>{{items.materialNumber}}</td>
                    <td class="addCommaInvoices">{{items.doses}}</td>
                    <td>&#163;{{items.unitPrice | number : '1.2-2'}}
                    </td>
                    <td>&#163;{{items.netAmount | number : '1.2-2'}}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div class="invoice_detailtotalcal invoice_detailsubtotal">
            <div class="invoice_detailtotalcallabel">{{"allinvoice.subtotaluk" | cxTranslate}}</div>
            <div class="invoice_detailtotalcalLine"></div>
            <div class="invoice_detailtotalcalamount invoice_detailsubtotalAmount">&#163;{{rightsectionresponse.subTotal | number : '1.2-2'}}</div>
          </div>
          <div class="invoice_detailtotalcal invoice_detailtax">
            <div class="invoice_detailtotalcallabel">{{"allinvoice.vatlabel" | cxTranslate}}</div>
            <div class="invoice_detailtotalcalLine"></div>
            <div class="invoice_detailtotalcalamount invoice_detailtaxAmount">&#163;{{rightsectionresponse.vat | number : '1.2-2'}}</div>
          </div>
          <div class="invoice_detailtotalcost">
            <div class="invoice_detailtotalcostlabel">{{"allinvoice.totalcostlabel" | cxTranslate}}</div>
            <div class="invoice_detailtotalcostamount">&#163;{{rightsectionresponse.total | number : '1.2-2'}}</div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  }
</section>
}
